<script>
  import { getUrlFromId } from "../sanityClient";

  export let file;
  export let title;
</script>

<div class="pdf-wrapper">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    ><path
      d="M4 22v-20h16v11.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-14.386h-20v24h10.189c3.163 0 9.811-7.223 9.811-9.614zm-5-1.386h-10v-1h10v1zm0-4h-10v1h10v-1zm0-3h-10v1h10v-1z"
    />
  </svg>
  <a
    target="_blank"
    rel="noopener noreferrer"
    class="pdf-button"
    href={getUrlFromId(file.asset._ref)}
  >
    {title}
  </a>
</div>

<style>
  .pdf-wrapper {
    display: flex;
    align-items: center;
    margin: 24px 0;
  }

  .pdf-button {
    display: block;
    color: #555;
    margin-left: 12px;
    border-bottom: 1px dotted #555;
  }

  .pdf-button:hover {
    color: inherit;
  }
</style>
